import React from 'react'
// import Styles from './Signup.module.css'
import SignupForm from '../components/signup/SignupForm'
import GotoTop from '../components/GotoTop'

function SignUp() {
  return (
	  <div>
		  <GotoTop/>
		  <SignupForm/>
	  </div>
	);
}

export default SignUp;